import React, { useEffect } from 'react';
import { useLocale } from '@byte-design/config';
import { classnames } from '@bydesign-ui/utils';
import { useRefCallback } from '@bydesign-ui/hooks';
import { RcTrigger, RcUploadProvider, useCreateFileUpload } from './rc-upload';
import { FileList } from './components/FileList';
export function Upload(props) {
  var className = props.className,
      children = props.children,
      _props$listType = props.listType,
      listType = _props$listType === void 0 ? 'text' : _props$listType,
      _props$accept = props.accept,
      accept = _props$accept === void 0 ? '*/*' : _props$accept,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$autoUpload = props.autoUpload,
      autoUpload = _props$autoUpload === void 0 ? true : _props$autoUpload,
      _props$maxLength = props.maxLength,
      maxLength = _props$maxLength === void 0 ? -1 : _props$maxLength,
      uploadUrl = props.uploadUrl,
      name = props.name,
      _props$headers = props.headers,
      headers = _props$headers === void 0 ? {} : _props$headers,
      _props$data = props.data,
      data = _props$data === void 0 ? {} : _props$data,
      _props$withCredential = props.withCredentials,
      withCredentials = _props$withCredential === void 0 ? false : _props$withCredential,
      _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value,
      iconRender = props.iconRender,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      onError = props.onError,
      onDisabledChange = props.onDisabledChange,
      customRequest = props.customRequest;
  var cls = classnames(className);
  var localeCount = useLocale('upload.error.overflow-count');
  var handleError = useRefCallback(onError);
  var handleChange = useRefCallback(onChange);
  var handleValueChange = useRefCallback(onValueChange);
  var handleDisabledChange = useRefCallback(onDisabledChange);
  var fileUpload = useCreateFileUpload();
  useEffect(function () {
    var valueChange = function valueChange(files) {
      handleValueChange && handleValueChange(files);
    };

    fileUpload.addListener('error', handleError);
    fileUpload.addListener('change', handleChange);
    fileUpload.addListener('value-change', valueChange);
    fileUpload.addListener('disabled-change', handleDisabledChange);
    return function () {
      fileUpload.removeListener('error', handleError);
      fileUpload.removeListener('change', handleChange);
      fileUpload.removeListener('value-change', valueChange);
      fileUpload.destroy();
    };
  }, []);
  useEffect(function () {
    fileUpload.updateOptions({
      maxLength: maxLength,
      autoUpload: autoUpload,
      uploadUrl: uploadUrl,
      name: name,
      accept: accept,
      multiple: multiple,
      headers: headers,
      data: data,
      withCredentials: withCredentials,
      errors: {
        overflowCount: localeCount
      },
      customRequest: customRequest
    });
  }, [maxLength, autoUpload, uploadUrl, name, accept, multiple, headers, data, withCredentials, customRequest]);
  useEffect(function () {
    fileUpload.updateValue(value);
  }, [value]);
  return React.createElement(RcUploadProvider, {
    upload: fileUpload
  }, React.createElement("div", {
    className: cls
  }, React.createElement(RcTrigger, {
    accept: accept,
    multiple: multiple,
    disabled: disabled
  }, children), React.createElement(FileList, {
    type: listType,
    iconRender: iconRender
  })));
}